import { Box, Stack } from '@mui/material'

import { BodyText } from '@/components/atoms/BodyText'
import { MetaText } from '@/components/atoms/MetaText'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import type { ConversationSegment } from '@/shared/types/yakurekiCore'

// 共有カーネルの文字起こしが付ける話者の語は薬剤師向け (薬剤師 / 患者)。栄養相談の系統の文字起こしは
// 管理栄養士 / お客様 で付けるが、それより前の記録は薬剤師 / 患者 のまま残っているので画面で写す
// (先方に見せる画面に「薬剤師」「患者」を出さない。語彙の持ち主は呼び出し側)。
const SPEAKER_LABELS: Record<string, string> = {
  薬剤師: '管理栄養士',
  患者: 'お客様',
}

interface Props {
  segments: ConversationSegment[]
}

// 会話の全文 (記録の文字起こし)。回の「会話」のタブの中身で、読むだけ (右の列は要約 = Excel の右半分で、
// 会話の全文は出力に載らない)。見出しはタブの名前が言うので持たない。行の形は薬剤師の会話タブの発話
// (ConversationView) と同じで、話者を左の gutter・本文を右に baseline 揃え。
export const NutritionConversation = ({ segments }: Props) => {
  const rows = segments.filter((seg) => seg.content)
  if (rows.length === 0) {
    return (
      <BodyText sx={{ color: colorTokens.fg.muted }}>
        この回の会話はありません
      </BodyText>
    )
  }
  return (
    <Box>
      <Stack spacing={0.5}>
        {rows.map((seg, i) => (
          <Box
            key={i}
            sx={{
              display: 'grid',
              gridTemplateColumns: '80px 1fr',
              gap: 1,
              alignItems: 'baseline',
            }}
          >
            <MetaText>{SPEAKER_LABELS[seg.speaker] ?? seg.speaker}</MetaText>
            <BodyText sx={{ whiteSpace: 'pre-wrap' }}>{seg.content}</BodyText>
          </Box>
        ))}
      </Stack>
    </Box>
  )
}
